import React from "react";

import Link from "next/link";
import { useTheme } from "@/hooks/useTheme";
import useApiEnvSwitch from "@/hooks/api-env/useApiEnvSwitch";
import { SupTalk, SupCog, SupChevronRight, SupCoin } from "@repo/core-ui";

import ThemeToggle from "@/components/Layout/ThemeToggle";
import AccountSwitchEnv from "@/components/Ui/Account/SwitchEnv";
import Web3Account from "@/components/Web3/Account";
import { MenuItem } from "@/components/MobileLayout/Menu/MenuItem";
import MobileLayoutMenuWallet from "@/components/MobileLayout/Menu/Wallet";
import { MenuDrawer, type MenuDrawerProps } from "@/components/MobileLayout/Drawers/Base";

import { notifyMessage } from "@/utils";
import { twMerge } from "tailwind-merge";
import { useStoredDataDispatch } from "@/store";

export function MoreDrawer(props: Omit<MenuDrawerProps, "children">) {
  const storedDispatch = useStoredDataDispatch();
  const { displayApiEnv } = useApiEnvSwitch();
  const { theme, toggleTheme } = useTheme();

  const action = <Web3Account fullWord className="justify-center" hideIcon />;

  function openMava() {
    // @ts-ignore
    if (window && window.MavaWebChatToggle !== undefined) {
      // @ts-ignore
      window.MavaWebChatToggle();
    } else {
      notifyMessage("Mava not available", "Please contact us directly using Discord", "error");
    }

    props.onClose?.();
  }

  return (
    <MenuDrawer {...props} contentClassName={twMerge("flex flex-col justify-between", props.contentClassName)} actionButton={action}>
      <MobileLayoutMenuWallet />
      <nav className="flex flex-col">
        <button onClick={openMava}>
          <MenuItem icon={<SupTalk className="size-6" />} title="Get Help" />
        </button>
        <Link href="https://opencover.com/superform" target="_blank" onClick={props.onClose}>
          <MenuItem icon={<SupCoin className="size-6" />} title="Insurance" />
        </Link>
        <button
          onClick={() => {
            storedDispatch({ type: "setOverlay", overlay: "rewards-apy" });
          }}
        >
          <MenuItem icon={<SupCog className="size-6" />} title="Settings" append={<SupChevronRight className="size-6" />} />
        </button>
        <div className="flex h-14 items-center pl-4 pr-1">
          <ThemeToggle theme={theme} onToggle={toggleTheme} />
        </div>
        {displayApiEnv && (
          <div className="flex h-14 items-center pl-4 pr-1">
            <AccountSwitchEnv />
          </div>
        )}
      </nav>
    </MenuDrawer>
  );
}
